@if (entries$ | async; as entries) {
  <app-order-summary [cart]="cart$ | async" [cartPage]="true"></app-order-summary>
  @if (entries.length && !buttonSpinner) {
    <button class="btn btn-primary btn-block" type="button" (click)="realtimeStock()">
      {{ 'cartDetails.proceedToCheckout' | cxTranslate }}
    </button>
  }
  @if (buttonSpinner) {
    <button class="btn btn-primary btn-block " type="button" disabled="disabled" >
      <cx-spinner></cx-spinner>
      {{ 'cartDetails.proceedToCheckout' | cxTranslate }}
    </button>
  }
}